/* @flow */

import type { CombinedReducers } from '../../../../redux/reducers';
import type { NETGEM_API_V8_REQUEST_RESPONSE } from '../types/RequestResponse';

import { HeaderName, HeaderValue } from '../constants/Headers';
import { buildHeaderList } from '../helpers/RequestHeaders';
import { HttpMethod } from '../types/HttpMethod';
import sendV8Request from './v8';

const sendV8GenericRequest: (
  url: string,
  method: HttpMethod,
  authenticationToken: string | null,
  state: ?CombinedReducers,
  signal: ?AbortSignal,
  responseType: ?string,
  eTag: ?string,
) => Promise<NETGEM_API_V8_REQUEST_RESPONSE> = (url, method, authenticationToken, state, signal, responseType, eTag) => {
  const headers: Array<string> = [];

  // Empty string means no response expected
  if (responseType !== '') {
    headers.push(HeaderName.Accept);
    if (responseType === undefined || responseType === null) {
      // Default is 'application/json'
      headers.push(HeaderValue.ApplicationJson);
    } else {
      // Add provided accepted type
      headers.push(responseType);
    }
  }

  if (eTag) {
    headers.push(!method || method === HttpMethod.GET ? HeaderName.IfNoneMatch : HeaderName.IfMatch);
    headers.push(eTag);
  }

  const headerList = buildHeaderList(...headers);
  return sendV8Request(url, authenticationToken, null, headerList, state, signal, null, method);
};

export { sendV8GenericRequest };
